<template>
    <div class="col-12">
        <div class="col-12">
            <div class="form-group">
                <label class="control-label" for="name">{{$lang('Biblioteka')}}</label>
                <autocomplete
                    :autoSelect="true"
                    id="auto-name"
                    :search="search"
                    @submit="saveName"
                    :placeholder="$lang('Nazwa')"
                    ref="name"
                ></autocomplete>
                <input id="name" type="hidden" name="name" :value="name">
            </div>
        </div>

        <slot name="password"></slot>

        <div class="col-12">
            <div class="form-group">
                <a href="" onclick="return false" v-on:click="showHelp()">
                    <i id="help_link" class="fa fa-arrow-circle-right" aria-hidden="true"></i>
                    {{$lang('Nie pamiętasz hasła?')}}
                </a>
                <p id="help" class="col-12" :hidden="true">
                    {{$lang('Skontaktuj się z obecnie dyżurującym konsultantem:')}}
                    <br>
                    <b>504 143 443</b>
                </p>
            </div>
        </div>

        <hr class="colorgraph">

        <div class="form-row">
            <div
                class="col-xs-12 col-sm-6 col-md-6 col-lg-6 m-auto">
                <div class="form-group">
                    <input type="submit" class="btn btn-primary btn-block btn-lg"
                           :value="$lang('Zaloguj')" :disabled="!validName">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Autocomplete from '@trevoreyre/autocomplete-vue'

    export default {
        name: 'prolib-login-form',
        components: {Autocomplete},
        props: ['libraries', 'cookie_name'],
        data() {
            return {
                validName: false,
                name: this.cookie_name
            }
        },
        methods: {
            search(input) {
                this.name = input;
                this.validName = false;
                let results = [];
                if (input.length >= 1) {
                    const self = this;
                    this.libraries.forEach(function (library) {
                        if (library.name.toLowerCase().includes(input.toLowerCase())) {
                            results.push(library.name);
                        }
                        if (library.name === input) {
                            self.validName = true;
                        }
                    })
                }
                return results;
            },
            saveName(result) {
                this.name = result;
                this.validName = true;
            },
            showHelp() {
                const link = document.getElementById('help_link');
                const div = document.getElementById('help');
                div.hidden = !div.hidden;
                if(link.classList.contains('fa-arrow-circle-right')) {
                    link.classList.remove('fa-arrow-circle-right');
                    link.classList.add('fa-arrow-circle-down');
                } else {
                    link.classList.remove('fa-arrow-circle-down');
                    link.classList.add('fa-arrow-circle-right');
                }
            }
        },
        mounted() {
            this.$refs.name.setValue(this.name);
            if (this.name !== '') {
                this.validName = true;
            }
            let self = this;

            $(document).ready(function () {
                $(window).keydown(function (event) {
                    const autocomplete = document.getElementById('auto-name');
                    if (document.activeElement === autocomplete) {
                        if (event.keyCode === 13) {
                            event.preventDefault();
                            return false;
                        }
                        if (event.keyCode === 9) {
                            self.saveName(autocomplete.value);
                        }
                    }
                });
            });
        }
    }
</script>
